import checkbox from './checkbox'
import checkboxGroup from './checkbox-group'
export default { checkbox, checkboxGroup }
